

































import Vue from "vue";
import { WordSelectOptions, WordSelectSentenceElement } from "@tt-app/types";

import WordSelectAnswerExplanation from "@tt-app/components/exercise/wordSelect/WordSelectAnswerExplanation.vue";

import IconChevronDown from "@joyz/app-core/assets/icons/transparent/ChevronDown.svg";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

interface Data {
  dropdownOpen: boolean;
  icons: {
    [key: string]: string;
  };
}

interface Methods {
  dynamicComponent: (componentDefinition: any) => string;
  toggleCollapse: () => void;
}

interface Computed {
  answer: {
    index: number;
    option: {
      number: number;
      text: string;
    };
  }[];
  answerExplanations: any;
  audio: string;
  components: any;
  correct: any;
  correctAnswer: any;
  explanationsCount: number;
  options: WordSelectOptions[];
  plainText: string[];
  problemUuid: string;
  selections: any;
  sentence: any;
  structure: WordSelectSentenceElement[];
}

interface Props {
  answers: {
    [key: string]: {
      [key: number]: {
        index: number;
        option: {
          number: number;
          text: string;
        };
      }[];
    };
  };
  audioDecoderPlayer: AudioDecoderPlayer;
  body: any;
  collapse: any;
  default: any;
  exerciseAccuracy: any;
  footer: any;
  header: any;
  problems: any;
  totalQuestions: number;
  type: any;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "WordSelectReviewCard",
  components: {
    WordSelectAnswerExplanation
  },
  props: {
    answers: {
      type: Object,
      default: () => ({})
    },
    audioDecoderPlayer: {
      type: AudioDecoderPlayer,
      required: true
    },
    body: {
      type: Array,
      default: () => []
    },
    collapse: {
      type: Boolean,
      default: undefined
    },
    default: {
      type: String,
      default: undefined
    },
    exerciseAccuracy: {
      type: Object,
      required: true
    },
    footer: {
      type: Array,
      default: () => []
    },
    header: {
      type: Array,
      default: () => []
    },
    problems: {
      type: Object,
      default: () => ({})
    },
    totalQuestions: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    const dropdownOpen = false;

    return {
      dropdownOpen,
      icons: {
        chevronDown: IconChevronDown
      }
    };
  },
  computed: {
    answer() {
      return Object.values(this.answers[this.problemUuid]).reduce<
        {
          index: number;
          option: { number: number; text: string };
        }[]
      >((previousResult, currentElement) => {
        return [...previousResult, ...currentElement];
      }, []);
    },

    answerExplanations() {
      const plainText = this.components.find((component: any) => {
        return component.type === "PLAIN_TEXT";
      });

      let explanations = [];
      if (plainText) {
        explanations = plainText.body
          .map((element: any) => {
            return element.trim();
          })
          .filter(Boolean);
      }

      return explanations;
    },

    audio() {
      return this.problems[this.problemUuid].audio;
    },

    components() {
      return this.body;
    },

    correct() {
      return this.exerciseAccuracy[this.problemUuid].isCorrect;
    },

    correctAnswer() {
      return this.exerciseAccuracy[this.problemUuid].correctAnswer;
    },

    explanationsCount() {
      return this.answerExplanations.length;
    },

    options() {
      return this.problems[this.problemUuid].options;
    },

    plainText() {
      return this.problems[this.problemUuid].plainText;
    },

    problemUuid() {
      return this.body[0].problemUuid;
    },

    selections() {
      return [];
    },

    sentence() {
      const answer = [...this.answer];
      const correctAnswer = [...this.correctAnswer];

      return this.structure.map((sentenceElement, index, array) => {
        let options;
        if (sentenceElement.id) {
          const optionsArray = this.options.find(optionArray => {
            return optionArray.blankId === sentenceElement.id;
          });
          options = optionsArray?.options;
        } else {
          options = this.options[0].options;
        }

        let correct;
        let incorrectText;
        let text;
        if (sentenceElement.type === "TEXT") {
          text = sentenceElement.text;
        } else if (sentenceElement.type === "BLANK") {
          const blankAnswer = answer.shift();
          const correctBlankAnswer = correctAnswer.shift();

          if (blankAnswer?.option.number === correctBlankAnswer) {
            correct = true;
            text = blankAnswer?.option.text;
          } else {
            correct = false;
            const incorrectOption = options?.find(option => {
              return option.number === blankAnswer?.option.number;
            });
            incorrectText = incorrectOption?.text;

            const correctAnswer = options?.find(option => {
              return option.number === correctBlankAnswer;
            });
            text = correctAnswer?.text;
          }
        }

        let noPrecedingSpace;
        if (text) {
          noPrecedingSpace =
            text[0].match(/^[.,;:!?。、；：！？]/) || array[index - 1]?.text?.match(/^['"`]$/);
        }

        return { correct, incorrectText, noPrecedingSpace, text };
      });
    },

    structure() {
      return this.problems[this.problemUuid].structure;
    }
  },
  methods: {
    dynamicComponent(componentDefinition) {
      switch (componentDefinition.type) {
        case "SEPARATOR":
          return "";

        case "WORD_SELECT_ANSWER_EXPLANATION":
          return "word-select-answer-explanation";

        default:
          return "";
      }
    },
    toggleCollapse() {
      this.dropdownOpen = !this.dropdownOpen;
    }
  }
});
